import { makeAutoObservable } from "mobx";

export class FormModel {
  editedId?: string = undefined;
  editedField?: Record<string, any> = undefined;

  constructor() {
    makeAutoObservable(this);
  }

  get editing() {
    return this.editedId !== undefined;
  }

  startEditing(editedId: string, editedField: Record<string, any>) {
    this.editedField = editedField;
    this.editedId = editedId;
  }

  stopEditing() {
    this.editedId = undefined;
    this.editedField = undefined;
  }
}
